import {
  MentorMetricsRow,
  MentorMetricsSummary,
  MentorMetricsTablePage,
} from "@/lib/api/mentor-metrics-dashboard";

const emptyRollingFields = {
  appealScore: null,
  appealAppearances: 0,
  appealSelections: 0,
  appealReliable: false,
  averageResponseTimeSeconds: null,
  d3RetentionRate: null,
  d3CohortSize: 0,
  d3Returned: 0,
  d3Reliable: false,
} as const;

export const mergeMentorMetricsSummary = (
  month: MentorMetricsSummary,
  rolling: MentorMetricsSummary,
): MentorMetricsSummary => ({
  ...month,
  appealScoreAvailable: rolling.appealScoreAvailable,
  averageAppealScore: rolling.averageAppealScore,
  averageResponseTimeSeconds: rolling.averageResponseTimeSeconds,
  averageD3RetentionRate: rolling.averageD3RetentionRate,
});

const applyRollingMetrics = (
  row: MentorMetricsRow,
  rolling: MentorMetricsRow | undefined,
): MentorMetricsRow => {
  if (!rolling) {
    return { ...row, ...emptyRollingFields };
  }

  return {
    ...row,
    appealScore: rolling.appealScore,
    appealAppearances: rolling.appealAppearances,
    appealSelections: rolling.appealSelections,
    appealReliable: rolling.appealReliable,
    averageResponseTimeSeconds: rolling.averageResponseTimeSeconds,
    d3RetentionRate: rolling.d3RetentionRate,
    d3CohortSize: rolling.d3CohortSize,
    d3Returned: rolling.d3Returned,
    d3Reliable: rolling.d3Reliable,
  };
};

const applyMonthCaseload = (
  row: MentorMetricsRow,
  month: MentorMetricsRow | undefined,
): MentorMetricsRow => {
  if (!month) {
    return {
      ...row,
      engagedTeens: null,
      activeCaseload: null,
    };
  }

  return {
    ...row,
    engagedTeens: month.engagedTeens,
    activeCaseload: month.activeCaseload,
    tenureDays: month.tenureDays,
    tenureMonths: month.tenureMonths,
    onboardedAt: month.onboardedAt,
  };
};

export const mergeMentorMetricsTablePage = (
  primary: MentorMetricsTablePage,
  overlayRows: MentorMetricsRow[],
  mode: "apply-rolling" | "apply-month-caseload",
  appealScoreAvailable: boolean,
): MentorMetricsTablePage => {
  const overlayById = new Map(overlayRows.map((row) => [row.mentorId, row]));

  return {
    ...primary,
    appealScoreAvailable,
    rows: primary.rows.map((row) =>
      mode === "apply-rolling"
        ? applyRollingMetrics(row, overlayById.get(row.mentorId))
        : applyMonthCaseload(row, overlayById.get(row.mentorId)),
    ),
  };
};
